import {
    PortfolioPlBenchmarkType,
    PortfolioPlStreamRequest,
} from 'communication/types/portfolioPl/PortfolioPlStreamRequest';
import { AppSettingsState } from 'app/store/appSettings/AppSettingsState';
import State from 'store/State';
import { buildPortfolioPlConfigSlice } from 'widgets/portfolioPl/store/config/configSlice';
import { PortfolioSelectionWrapper } from 'portfolio/PortfolioSelectionWrapper';
import { PnlBenchmark } from 'utils/PnL';

const {
    selectors: { selectConfigState },
} = buildPortfolioPlConfigSlice();

export function createPortfolioPlStreamRequest(
    orderIds: string[],
    _portfolioSelection: PortfolioSelectionWrapper,
    widgetKey: string,
    appSettings: AppSettingsState,
    state: State
): PortfolioPlStreamRequest | undefined {
    const { benchmarkType, index } = selectConfigState(state, widgetKey);
    const { symbology, currencyCode: currency } = appSettings;

    const streamBenchmarkType =
        benchmarkType === PnlBenchmark.IndividualOrderArrival
            ? 'ARRIVAL'
            : (benchmarkType.toUpperCase() as PortfolioPlBenchmarkType);

    return {
        orderIds: orderIds.join(),
        benchmarkType: streamBenchmarkType,
        indexSymbology: symbology,
        indexSymbol: index,
        useIndividualOrderArrival:
            benchmarkType === PnlBenchmark.IndividualOrderArrival,
        currency,
    };
}
